import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';
import { CatalogoProdutos } from '@/features/catalogo/page/default/produtos/CatalogoProdutos';

const schema = z.object({
    pro_idpk: z.number().optional(),
    visualizacao: z.boolean().optional(),
});

export const Route = createFileRoute('/p/catalogo/$slug/_default/produtos')({
    component: Component,
    validateSearch: schema,
});

function Component() {
    const { slug } = Route.useParams();

    return <CatalogoProdutos slug={slug} />;
}
